// Homepage action creators for fetching dynamic data

export const getHomepageStats = () => ({
  type: 'GET_HOMEPAGE_STATS',
  payload: {
    path: 'v1/api/homepage/stats/',
    method: 'GET',
  },
});

export const getHomepageCharts = () => ({
  type: 'GET_HOMEPAGE_CHARTS',
  payload: {
    path: 'v1/api/homepage/charts/',
    method: 'GET',
  },
});

export const getHomepageTopData = () => ({
  type: 'GET_HOMEPAGE_TOP_DATA',
  payload: {
    path: 'v1/api/homepage/top-data/',
    method: 'GET',
  },
});

export const getHomepageAttackSimulations = () => ({
  type: 'GET_HOMEPAGE_ATTACK_SIMULATIONS',
  payload: {
    path: 'v1/api/homepage/attack-simulations/',
    method: 'GET',
  },
});
